<template>
  <div class="alert alert-danger position-fixed shadow alert-dismissible w-100"
       role="alert"
       style="left: 0;bottom:0;z-index:10000;"
       v-if="error">
    <div><i class="fas fa-exclamation-triangle"></i> {{error}}</div>

    <button type="button" class="close" @click="closeError">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</template>

<script>
  export default {
    name: "Header",

    computed: {
      error() {
        return this.$store.state.error;
      }
    },

    methods: {
      closeError() {
        this.$store.commit('SET_ERROR', '');
      },
    },
  };
</script>
